import React from 'react'
import { Row, Col, Button, Form, FormGroup, Label, Input, Card } from 'reactstrap'
import { withTranslation } from 'react-i18next'
import altProfileImage from 'assets/img/profile.svg'
import PropTypes from 'prop-types'
import {
    Medal,
    User,
    Star,
    MapPin,
    ShareNetwork,
    TwitterLogo,
    GithubLogo,
    FacebookLogo,
    LinkedinLogo,
    InstagramLogo,
    SlackLogo,
    ListBullets,
} from "phosphor-react"
import { replaceNull, processError } from '../../lib/lib'
import Log from '../../components/Logs/Log.jsx'
import api from '../../api/api'
import Cookies from 'universal-cookie'
import Skeleton from '../../components/UI/Skeleton'
const cookies = new Cookies()

class Profile extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            useravatar: '',
            username: "",
            email: '',
            achievements: [],
            login: '',
            active: true,
            role: '',
            birthday: '',
            phone: '',
            website: '',
            language: '',
            address: '',
            livingAddress: '',
            postIndex: '',
            city: '',
            region: '',
            country: '',
            sex: "",
            rights: 'user',
            notifications: {
                email: false,
                messages: false,
                sms: false,
            },
            twitter: '',
            vkontakte: '',
            facebook: '',
            linkedin: '',
            instagram: '',
            slack: '',
            nots: {
                news: {
                    email: false,
                    messages: false,
                    sms: false,
                    push: false,
                },
                promotions: {
                    email: false,
                    messages: false,
                    sms: false,
                    push: false,
                },
                messages: {
                    email: false,
                    messages: false,
                    sms: false,
                    push: false,
                },
                webinars: {
                    email: false,
                    messages: false,
                    sms: false,
                    push: false,
                },
                login: {
                    email: false,
                    messages: false,
                    sms: false,
                    push: false,
                },
            },
            logs: [],
            location: '',
            locationPlaceholder: '',
            notsLoaded: false,
            personalInfoLoaded: false,
            socialNetworksLoaded: false,
            userLogsLoaded: false,
            useravatarLoaded: false,
            achievementsLoaded: false,
            dataLoaded: false,
            imageLoaded: false,
            personalInfoChanging: false,
            // eslint-disable-next-line no-undef
            imageUrl: process.env.REACT_APP_IMAGEURL,
        }
        this.changeBirthday = this.changeBirthday.bind(this)
        this.changePhone = this.changePhone.bind(this)
        this.changeWebsite = this.changeWebsite.bind(this)
        this.changeLanguage = this.changeLanguage.bind(this)
        this.changeSex = this.changeSex.bind(this)
        this.changeNotEmail = this.changeNotEmail.bind(this)
        this.changeNotMessages = this.changeNotMessages.bind(this)
        this.changeNotSms = this.changeNotSms.bind(this)
        this.changeAddress = this.changeAddress.bind(this)
        this.changeLivAddress = this.changeLivAddress.bind(this)
        this.changePostIndex = this.changePostIndex.bind(this)
        this.changeCity = this.changeCity.bind(this)
        this.changeRegion = this.changeRegion.bind(this)
        this.changeCountry = this.changeCountry.bind(this)
        this.changeTwitter = this.changeTwitter.bind(this)
        this.changeVkontakte = this.changeVkontakte.bind(this)
        this.changeFacebook = this.changeFacebook.bind(this)
        this.changeLinkedin = this.changeLinkedin.bind(this)
        this.changeInstagram = this.changeInstagram.bind(this)
        this.changeSlack = this.changeSlack.bind(this)
        this.changeNot = this.changeNot.bind(this)
        this.changePersonalInfo = this.changePersonalInfo.bind(this)
        this.changeSocialNetworks = this.changeSocialNetworks.bind(this)
        this.fileSelectHandler = this.fileSelectHandler.bind(this)
        this.convertToBase64 = this.convertToBase64.bind(this)
        this.changeLocation = this.changeLocation.bind(this)
        this.routeTo = this.routeTo.bind(this)
        this.logout = this.logout.bind(this)
    }

    componentWillMount() {
        const token = cookies.get('accessToken')
        const lang = this.props.i18n.language

        let arrPromise = [
            api.getUserSettings({ token, lang })
                .then(({ notifications }) => {
                    if (notifications) {
                        this.setState({ nots: notifications, notsLoaded: true })
                    }
                })
                .catch((e) => {
                    console.log(e)
                    processError(e, this.props.history)
                }),
            api.getPersonalInfo({ token, lang })
                .then((allData) => {
                    const userData = allData[0]
                    const profileData = allData[1]
                    const addressData = allData[2]

                    if (userData.status === "ok") {
                        const clearUserData = replaceNull(userData.data)
                        this.setState({
                            email: clearUserData.userEmail,
                            language: clearUserData.userLanguage || 'en',
                            login: clearUserData.userLogin,
                            phone: clearUserData.userMobile,
                            role: clearUserData.userType,
                        })
                    }

                    if (profileData.status === "ok") {
                        const clearProfileData = replaceNull(profileData.data)
                        this.setState({
                            birthday: clearProfileData.profileBirthDate,
                            username: `${clearProfileData.profileFirstName} ${clearProfileData.profileLastName}`,
                            sex: String(clearProfileData.profileGender),
                        })
                    }

                    if (addressData.status === "ok") {
                        const clearAddressData = replaceNull(addressData.data)
                        this.setState({
                            livingAddress: clearAddressData.profileAddress,
                            address: clearAddressData.profilePostAddress,
                            postIndex: clearAddressData.profilePostZipCode,
                            city: clearAddressData.profileCityId,
                            region: clearAddressData.profileRegionId,
                            country: clearAddressData.profileCountryId,
                        })
                    }

                    this.setState({ personalInfoLoaded: true })
                })
                .catch((e) => processError(e, this.props.history)),
            api.getSocialNetworks({ token, lang })
                .then((res) => {
                    if (res.status === "ok") {
                        const clearData = replaceNull(res.data)
                        this.setState({
                            twitter: clearData.profileTwitterLink,
                            linkedin: clearData.profilelinkedIdLink,
                            vkontakte: clearData.profileVkLink,
                            facebook: clearData.profileFbLink,
                            instagram: clearData.profileInstagramLink,
                            slack: clearData.profileSlackLink,
                        })
                    }
                    this.setState({ socialNetworksLoaded: true })
                })
                .catch((e) => processError(e, this.props.history)),
            api.getUserLogs({ token, lang, start: 1, end: 10, sort: 'createdAt', order: 'DESC' })
                .then((res) => {
                    this.setState({ userLogsLoaded: true, logs: res.rows })
                })
                .catch((e) => processError(e, this.props.history)),
            this.getProfileImage(token).then((useravatar) => this.setState({ useravatar, useravatarLoaded: true })),
            api.getUserCertificates({ token, lang })
                .then(({ data }) => {
                    const certificates = data.certificates.map(({ medalType, courseName, file }) => {
                        return { courseName, file, medalType }
                    })
                    this.setState({ achievementsLoaded: true, achievements: certificates })
                })
                .catch((e) => processError(e, this.props.history)),
        ]
        Promise.all(arrPromise).then(() => this.setState({ dataLoaded: true }))
    }

    getProfileImage(token) {
        return new Promise((resolve, reject) => {
            api.getProfileImage(token)
                .then((profileImage) => {
                    if (profileImage.status === "ok") {
                        const useravatar = profileImage.data.medium
                        resolve(useravatar)
                    } else {
                        reject(profileImage.status)
                    }
                })
                .catch((e) => {
                    processError(e, this.props.history)
                    reject(e)
                })
        })
    }

    setLanguage(language) {
        const prevLang = cookies.get('i18next')
        this.languages = [
            {
                code: 'en',
                name: 'English',
                countryCode: 'gb',
            },
            {
                code: 'ru',
                name: 'Русский',
                countryCode: 'ru',
            },
            {
                code: 'de',
                name: 'Deutsch',
                countryCode: 'de',
            },
            {
                code: 'es',
                name: 'El español',
                countryCode: 'es',
            },
            {
                code: 'it',
                name: 'Italiano',
                countryCode: 'it',
            },
        ]
        let currentCountryCode
        this.languages.forEach((lang) => {
            if (lang.code === language) {
                currentCountryCode = lang.countryCode
            }
        })
        cookies.set('i18next', language, { path: '/' })
        cookies.set('countryCode', currentCountryCode, { path: '/' })
        if (prevLang !== language) window.location.reload()
    }

    changePersonalInfo(e) {
        e.preventDefault()
        this.setState({ personalInfoChanging: true })
        const token = cookies.get('accessToken')
        let userData = {
            // userMobile: this.state.phone,
            // userLanguage: this.state.language,
        }
        let profileData = {
            // profileBirthDate: this.state.birthday,
            // profileGender: this.state.sex,
        }
        let addressData = {}
        // let addressData = {
        //     profilePostAddress: this.state.address,
        //     profileAddress: this.state.livingAddress,
        //     profilePostZipCode: this.state.postIndex,
        //     profileCityId: this.state.city,
        //     profileRegionId: this.state.region,
        //     profileCountryId: this.state.country,
        // }
        userData = replaceNull(userData)
        profileData = replaceNull(profileData)
        addressData = replaceNull(addressData)
        let arrPromise = [
            api.changePersonalInfo({ token, data: { userData, profileData, addressData } })
                .then((res) => {
                    // res.map((newState) => this.setState({ ...newState.data }))
                    const language = res.find((newState) => newState.data.userLanguage !== undefined)
                    this.setLanguage(language.data.userLanguage)
                })
                .catch((e) => processError(e, this.props.history)),
            api.setUserSettings({ token, notifications: this.state.nots, location: this.state.location })
                .then(({ location }) => this.setState({ location }))
                .catch((e) => processError(e, this.props.history)),
        ]
        Promise.all(arrPromise).then(() => this.setState({ personalInfoChanging: false }))
    }

    changeSocialNetworks(e) {
        e.preventDefault()
        const token = cookies.get('accessToken')
        let data = {
            profileTwitterLink: this.state.twitter,
            profileLinkedIdLink: this.state.linkedin,
            profileVkLink: this.state.vkontakte,
            profileFbLink: this.state.facebook,
            profileInstagramLink: this.state.instagram,
            profileSlackLink: this.state.slack,
        }
        data = replaceNull(data)
        api.changeSocialNetworks({ token, data }).catch((e) => processError(e, this.props.history))
    }

    changeBirthday(e) {
        this.setState({ birthday: e.target.value })
    }
    changePhone(e) {
        this.setState({ phone: e.target.value })
    }
    changeWebsite(e) {
        this.setState({ website: e.target.value })
    }
    changeLanguage(e) {
        this.setState({ language: e.target.value })
    }
    changeSex(e) {
        this.setState({ sex: e.target.value })
    }
    changeNotEmail(e) {
        const notifications = this.state.notifications
        notifications.email = e.target.checked
        this.setState({ notifications })
    }
    changeNotMessages(e) {
        const notifications = this.state.notifications
        notifications.messages = e.target.checked
        this.setState({ notifications })
    }
    changeNotSms(e) {
        const notifications = this.state.notifications
        notifications.sms = e.target.checked
        this.setState({ notifications })
    }
    changeAddress(e) {
        this.setState({ address: e.target.value })
    }
    changeLivAddress(e) {
        this.setState({ livingAddress: e.target.value })
    }
    changePostIndex(e) {
        this.setState({ postIndex: e.target.value })
    }
    changeCity(e) {
        this.setState({ city: e.target.value })
    }
    changeRegion(e) {
        this.setState({ region: e.target.value })
    }
    changeCountry(e) {
        this.setState({ country: e.target.value })
    }
    changeTwitter(e) {
        this.setState({ twitter: e.target.value })
    }
    changeVkontakte(e) {
        this.setState({ vkontakte: e.target.value })
    }
    changeFacebook(e) {
        this.setState({ facebook: e.target.value })
    }
    changeLinkedin(e) {
        this.setState({ linkedin: e.target.value })
    }
    changeInstagram(e) {
        this.setState({ instagram: e.target.value })
    }
    changeSlack(e) {
        this.setState({ slack: e.target.value })
    }
    changeNot(e, subkey, key) {
        const token = cookies.get('accessToken')
        const nots = this.state.nots
        nots[subkey][key] = e.target.checked
        this.setState({ nots })
        api.setUserSettings({ token, notifications: nots, location: this.state.location }).catch((e) => processError(e, this.props.history))
    }

    convertToBase64(file) {
        // eslint-disable-next-line no-unused-vars
        return new Promise((resolve, reject) => {
            let myReader = new FileReader()
            // eslint-disable-next-line no-unused-vars
            myReader.onloadend = (e) => {
                resolve(myReader.result)
            }
            myReader.readAsDataURL(file)
        })
    }

    fileSelectHandler(e) {
        const token = cookies.get('accessToken')
        const file = e.target.files[0]
        if (file !== null) {
            this.convertToBase64(file).then((base64Image) => {
                api.writeAvatar({ token, base64Image })
                    .then(() => window.location.reload())
                    .catch((e) => processError(e, this.props.history))
            })
        }
    }

    deleteAvatar() {
        const token = cookies.get('accessToken')
        api.deleteAvatar({ token })
            .then(() => window.location.reload())
            .catch((e) => processError(e, this.props.history))
    }

    changeLocation(event) {
        this.setState({ location: event.value.place_id })
    }

    routeTo(link) {
        this.props.history.push(`/${link}/1`)
    }

    logout() {
        cookies.remove('accessToken')
        cookies.remove('accessExpired')
        cookies.remove('accessExpiredTime')
        cookies.remove('refreshToken')
        cookies.remove('systemFrontendSettings')
        this.props.history.push('/login')
    }

    render() {
        const { t } = this.props

        return (
            <div className="content achi-bg position-relative">
                <Row className="profile-row w-100 mx-0">
                    <Col xs={12} className="px-0">
                        <div className="profile-card avatar">
                            <div className="profile-avatar">
                                <div className="profile-avatar-card">
                                    {
                                        this.state.useravatarLoaded ?
                                            <React.Fragment>
                                                {!this.state.imageLoaded && (this.state.useravatar || altProfileImage) && <Skeleton className="profile-avatar-img" circle={true} width={97} height={97} image={true} />}
                                                {(this.state.useravatar || altProfileImage) && <img onLoad={() => this.setState({ imageLoaded: true })} src={this.state.useravatar || altProfileImage} className={`profile-avatar-img${this.state.imageLoaded ? '' : ' d-none'}`} alt="" width="97" height="97" />}
                                            </React.Fragment>
                                            :
                                            <Skeleton className="profile-avatar-img" circle={true} width={97} height={97} image={true} />
                                    }

                                    <div className="profile-avatar-text">
                                        <div className="profile-avatar-usename lg-font-size">{this.state.personalInfoLoaded ? this.state.username : <Skeleton width={100} />}</div>
                                        <div className="profile-avatar-email sm-font-size">{this.state.personalInfoLoaded ? this.state.email : <Skeleton width={150} />}</div>
                                        {/* <div className="profile-avatar-manage">
                                            <label className="profile-avatar-btn primary upload" htmlFor="upload-photo">{t('profile-change')}</label>
                                            <input
                                                type="file"
                                                name="file"
                                                accept=".png, .jpg"
                                                onChange={this.fileSelectHandler}
                                                id="upload-photo"
                                            />
                                            <Button type="button" className="profile-avatar-btn white" onClick={this.deleteAvatar}>{t('profile-delete')}</Button>
                                        </div> */}
                                    </div>
                                </div>
                                {
                                    this.state.achievementsLoaded ?
                                        this.state.achievements && this.state.achievements.length > 0 &&
                                        <div className="profile-achievements">
                                            <div className="profile-achievements-text">{t('profile-achievements')}</div>
                                            <div className="profile-achievements-medals">
                                                {
                                                    this.state.achievements.map((value, index) => (
                                                        <span
                                                            key={`medal-${index}`}
                                                            title={value.courseName}
                                                            className="medal-span"
                                                            onClick={() => window.open(`${this.state.imageUrl}/certificates/${value.file}`, "_blank")}
                                                        >
                                                            <Medal
                                                                size={20}
                                                                className="profile-achievements-medal primary-color"
                                                            />
                                                        </span>
                                                    ))
                                                }
                                            </div>
                                        </div>
                                        :
                                        <div className="profile-achievements">
                                            <div className="profile-achievements-text">{t('profile-achievements')}</div>
                                            <div className="profile-achievements-medals">
                                                <span className="medal-span">
                                                    <Skeleton className="profile-achievements-medal primary-color" circle={true} width={20} height={20} image={true} />
                                                </span>
                                            </div>
                                        </div>
                                }
                            </div>
                            <div className="profile-about">
                                <Row className="profile-about-row">
                                    <Col xs={6} className="profile-about-cell">
                                        <User size={16} />
                                        <div className="profile-about-cell-text sm-font-size">{t('profile-login')}</div>
                                    </Col>
                                    <Col xs={6} className="profile-about-info sm-font-size">{this.state.personalInfoLoaded ? this.state.login : <Skeleton />}</Col>
                                </Row>
                                {/*<Row className="profile-about-row">*/}
                                {/*    <Col xs={6} className="profile-about-cell">*/}
                                {/*        <Star size={16} />*/}
                                {/*        <div className="profile-about-cell-text sm-font-size">{t('profile-role')}</div>*/}
                                {/*    </Col>*/}
                                {/*    <Col xs={6} className="profile-about-info sm-font-size">{t(`profile-rights-${this.state.rights}`)}</Col>*/}
                                {/*</Row>*/}
                                <Row>
                                    <Col xs={12}>
                                        <Button className="logout-btn" onClick={this.logout}>
                                            <User className="icon" size={16} />
                                            <span className="sm-font-size">{t('profile-user-logout')}</span>
                                        </Button>
                                        {/* {
                                            this.state.dataLoaded ?
                                                <Button className="logout-btn" onClick={this.logout}>
                                                    <User className="icon" size={16} />
                                                    <span className="sm-font-size">{t('profile-user-logout')}</span>
                                                </Button>
                                                :
                                                <Skeleton className="logout-btn" button={true} height={36} />
                                        } */}
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row className="profile-row w-100 mx-0">
                    <Col xs={12} className="px-0">
                        <Form onSubmit={this.changePersonalInfo}>
                            <div className="profile-card">
                                <div className="personal-info">
                                    <Row>
                                        <Col xs={12}>
                                            <div className="personal-info-title">
                                                <User size={20} />
                                                <div className="personal-info-text lg-font-size">{t('profile-personal-info')}</div>
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs={12} sm={6} md={4}>
                                            <FormGroup>
                                                <Label className="custom-label xs-font-size" for="birthday">{t('profile-birthday')}</Label>
                                                {/* <Input disabled className="custom-input" id="birthday" type="date" name="birthday" value={this.state.birthday} onChange={this.changeBirthday}></Input> */}
                                                {
                                                    this.state.personalInfoLoaded ?
                                                        <Input disabled className="custom-input sm-font-size" id="birthday" type="text" name="birthday" value={this.state.birthday} onChange={this.changeBirthday}></Input>
                                                        :
                                                        <Skeleton height={38} button={true} className="custom-input sm-font-size" />
                                                }
                                            </FormGroup>
                                        </Col>
                                        <Col xs={12} sm={6} md={4}>
                                            <FormGroup>
                                                <Label className="custom-label xs-font-size" for="phone">{t('profile-phone')}</Label>
                                                {
                                                    this.state.personalInfoLoaded ?
                                                        <Input disabled className="custom-input sm-font-size" id="phone" type="text" name="birthday" value={this.state.phone} onChange={this.changePhone}></Input>
                                                        :
                                                        <Skeleton height={38} button={true} className="custom-input sm-font-size" />
                                                }
                                            </FormGroup>
                                        </Col>
                                        <Col xs={12} sm={6} md={4}>
                                            <FormGroup>
                                                <Label className="custom-label xs-font-size" for="website">{t('profile-website')}</Label>
                                                {
                                                    this.state.personalInfoLoaded ?
                                                        <Input disabled className="custom-input sm-font-size" id="website" type="text" name="website" value={this.state.website} onChange={this.changeWebsite}></Input>
                                                        :
                                                        <Skeleton height={38} button={true} className="custom-input sm-font-size" />
                                                }
                                            </FormGroup>
                                        </Col>
                                        <Col xs={12} sm={6} md={4}>
                                            <FormGroup>
                                                <Label className="custom-label xs-font-size" for="language">{t('profile-language')}</Label>
                                                {/* <Input disabled className="custom-input" type="select" name="language" id="language" value={this.state.language} onChange={this.changeLanguage}>
                                                    <option value="ru">{t('profile-language-russian')}</option>
                                                    <option value="en">{t('profile-language-english')}</option>
                                                </Input> */}
                                                {
                                                    this.state.personalInfoLoaded ?
                                                        <Input disabled className="custom-input sm-font-size" type="text" name="language" id="language" 
                                                            value={`${ this.state.language ? t(`profile-lang-${this.state.language}`) : ''}`} onChange={this.changeLanguage} />
                                                        :
                                                        <Skeleton height={38} button={true} className="custom-input sm-font-size" />
                                                }
                                            </FormGroup>
                                        </Col>
                                        <Col xs={12} sm={6} md={4}>
                                            <FormGroup tag="fieldset">
                                                <Label className="custom-label xs-font-size">{t('profile-sex')}</Label>
                                                <div className="radio-wrapper">
                                                    {
                                                        this.state.personalInfoLoaded ?
                                                            <React.Fragment>
                                                                <FormGroup check>
                                                                    <Label className="custom-label no-line-height sm-font-size" check>
                                                                        <Input disabled className="custom-input" type="radio" name="sex" value="1" checked={this.state.sex === '1' ? true : false} onChange={this.changeSex} />{' '}
                                                                        {t('profile-male')}
                                                                    </Label>
                                                                </FormGroup>
                                                                <FormGroup check className="ml-15px">
                                                                    <Label className="custom-label no-line-height sm-font-size" check>
                                                                        <Input disabled className="custom-input" type="radio" name="sex" value="2" checked={this.state.sex === '2' ? true : false} onChange={this.changeSex} />{' '}
                                                                        {t('profile-female')}
                                                                    </Label>
                                                                </FormGroup>
                                                            </React.Fragment>
                                                            :
                                                            <React.Fragment>
                                                                <Skeleton width={45} height={25} className="mr-3" />
                                                                <Skeleton width={45} height={25} />
                                                            </React.Fragment>
                                                    }
                                                </div>
                                            </FormGroup>
                                        </Col>
                                        {/* <Col xs={4}>
                                            <FormGroup tag="fieldset">
                                                <Label className="custom-label">{t('profile-notifications')}</Label>
                                                <div className="checkboxes-wrapper">
                                                    <FormGroup check>
                                                        <Label className="custom-label no-line-height" check>
                                                            <Input className="custom-input" type="checkbox" checked={this.state.notifications.email} onChange={this.changeNotEmail} />{' '}
                                                            {t('profile-notifications-email')}
                                                        </Label>
                                                    </FormGroup>
                                                    <FormGroup check className="ml-15px">
                                                        <Label className="custom-label no-line-height" check>
                                                            <Input className="custom-input" type="checkbox" checked={this.state.notifications.messages} onChange={this.changeNotMessages} />{' '}
                                                            {t('profile-notifications-messages')}
                                                        </Label>
                                                    </FormGroup>
                                                    <FormGroup check className="ml-15px">
                                                        <Label className="custom-label no-line-height" check>
                                                            <Input className="custom-input" type="checkbox" checked={this.state.notifications.sms} onChange={this.changeNotSms} />{' '}
                                                            {t('profile-notifications-sms')}
                                                        </Label>
                                                    </FormGroup>
                                                </div>
                                            </FormGroup>
                                        </Col> */}
                                    </Row>
                                </div>
                                <div className="personal-info pt-35px">
                                    <Row>
                                        <Col xs={12}>
                                            <div className="personal-info-title">
                                                <MapPin size={20} />
                                                <div className="personal-info-text lg-font-size">{t('profile-personal-address')}</div>
                                            </div>
                                        </Col>
                                    </Row>
                                    {/* <Row>
                                        <Col xs={4}>
                                            <FormGroup>
                                                <Label className="custom-label" for="address">{t('profile-address')}</Label>
                                                <Input className="custom-input" id="address" type="text" name="address" value={this.state.address} onChange={this.changeAddress}></Input>
                                            </FormGroup>
                                        </Col>
                                        <Col xs={4}>
                                            <FormGroup>
                                                <Label className="custom-label" for="livingAddress">{t('profile-living-address')}</Label>
                                                <Input className="custom-input" id="livingAddress" type="text" name="livingAddress" value={this.state.livingAddress} onChange={this.changeLivAddress}></Input>
                                            </FormGroup>
                                        </Col>
                                        <Col xs={4}>
                                            <FormGroup>
                                                <Label className="custom-label" for="postIndex">{t('profile-post-index')}</Label>
                                                <Input className="custom-input" id="postIndex" type="text" name="postIndex" value={this.state.postIndex} onChange={this.changePostIndex}></Input>
                                            </FormGroup>
                                        </Col>
                                    </Row> */}
                                    <Row>
                                        <Col xs={12}>
                                            <FormGroup>
                                                {/* <div className="d-none">
                                                    <GooglePlacesAutocomplete
                                                        apiKey={googleApiKey}
                                                        apiOptions={{ language: this.props.i18n.language }}
                                                        selectProps={{
                                                            placeholder: this.state.locationPlaceholder,
                                                            onChange: (event) => this.changeLocation(event),
                                                            isDisabled: true,
                                                        }}
                                                    />
                                                </div> */}
                                                {/* <Input disabled className="custom-input sm-font-size" type="text" placeholder={this.state.locationPlaceholder}></Input> */}
                                                <Input disabled className="custom-input sm-font-size" type="text"></Input>
                                            </FormGroup>
                                            {/* <FormGroup>
                                                <Label className="custom-label" for="city">{t('profile-city')}</Label>
                                                <Input className="custom-input" id="city" type="text" name="city" value={this.state.city} onChange={this.changeCity}></Input>
                                            </FormGroup> */}
                                        </Col>
                                        {/* <Col xs={4}>
                                            <FormGroup>
                                                <Label className="custom-label" for="region">{t('profile-region')}</Label>
                                                <Input className="custom-input" id="region" type="text" name="region" value={this.state.region} onChange={this.changeRegion}></Input>
                                            </FormGroup>
                                        </Col>
                                        <Col xs={4}>
                                            <FormGroup>
                                                <Label className="custom-label" for="country">{t('profile-country')}</Label>
                                                <Input className="custom-input" id="country" type="text" name="country" value={this.state.country} onChange={this.changeCountry}></Input>
                                            </FormGroup>
                                        </Col> */}
                                    </Row>
                                </div>
                                {/* <div className="profile-card-bottom">
                                    <Button type="submit" className="btn profile-avatar-btn primary">{t('profile-save')}</Button>
                                    <Button type="button" className="btn profile-avatar-btn white ml-10px">{t('profile-cancel')}</Button>
                                </div> */}
                            </div>
                        </Form>
                    </Col>
                </Row>
                <Row className="profile-row w-100 mx-0">
                    <Col xs={12} className="px-0">
                        <Form onSubmit={this.changeSocialNetworks}>
                            <div className="profile-card">
                                <div className="personal-info">
                                    <Row>
                                        <Col xs={12}>
                                            <div className="personal-info-title">
                                                <ShareNetwork size={20} />
                                                <div className="personal-info-text lg-font-size">{t('profile-social-network')}</div>
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs={12} sm={6} md={4}>
                                            <FormGroup>
                                                <Label className="custom-label xs-font-size" for="twitter">{t('profile-twitter')}</Label>
                                                <div className="profile-custom-input-wrapper">
                                                    {
                                                        this.state.socialNetworksLoaded ?
                                                            <React.Fragment>
                                                                <TwitterLogo size={20} className="logo-inside-input" />
                                                                <div className="vertical-line"></div>
                                                                <Input className="custom-input sm-font-size pl-45px" id="twitter" type="url" name="twitter" value={this.state.twitter} onChange={this.changeTwitter}></Input>
                                                            </React.Fragment>
                                                            :
                                                            <Skeleton height={38} button={true} />
                                                    }
                                                </div>

                                            </FormGroup>
                                        </Col>
                                        <Col xs={12} sm={6} md={4}>
                                            <FormGroup>
                                                <Label className="custom-label xs-font-size" for="vkontakte">{t('profile-vkontakte')}</Label>
                                                <div className="profile-custom-input-wrapper">
                                                    {
                                                        this.state.socialNetworksLoaded ?
                                                            <React.Fragment>
                                                                <GithubLogo size={20} className="logo-inside-input" />
                                                                <div className="vertical-line"></div>
                                                                <Input className="custom-input sm-font-size pl-45px" id="vkontakte" type="url" name="vkontakte" value={this.state.vkontakte} onChange={this.changeVkontakte}></Input>
                                                            </React.Fragment>
                                                            :
                                                            <Skeleton height={38} button={true} />
                                                    }
                                                </div>
                                            </FormGroup>
                                        </Col>
                                        <Col xs={12} sm={6} md={4}>
                                            <FormGroup>
                                                <Label className="custom-label xs-font-size" for="facebook">{t('profile-facebook')}</Label>
                                                <div className="profile-custom-input-wrapper">
                                                    {
                                                        this.state.socialNetworksLoaded ?
                                                            <React.Fragment>
                                                                <FacebookLogo size={20} className="logo-inside-input" />
                                                                <div className="vertical-line"></div>
                                                                <Input className="custom-input sm-font-size pl-45px" id="facebook" type="url" name="facebook" value={this.state.facebook} onChange={this.changeFacebook}></Input>
                                                            </React.Fragment>
                                                            :
                                                            <Skeleton height={38} button={true} />
                                                    }
                                                </div>
                                            </FormGroup>
                                        </Col>
                                        <Col xs={12} sm={6} md={4}>
                                            <FormGroup>
                                                <Label className="custom-label xs-font-size" for="linkedin">{t('profile-linkedin')}</Label>
                                                <div className="profile-custom-input-wrapper">
                                                    {
                                                        this.state.socialNetworksLoaded ?
                                                            <React.Fragment>
                                                                <LinkedinLogo size={20} className="logo-inside-input" />
                                                                <div className="vertical-line"></div>
                                                                <Input className="custom-input sm-font-size pl-45px" id="linkedin" type="url" name="linkedin" value={this.state.linkedin} onChange={this.changeLinkedin}></Input>
                                                            </React.Fragment>
                                                            :
                                                            <Skeleton height={38} button={true} />
                                                    }
                                                </div>
                                            </FormGroup>
                                        </Col>
                                        <Col xs={12} sm={6} md={4}>
                                            <FormGroup>
                                                <Label className="custom-label xs-font-size" for="instagram">{t('profile-instagram')}</Label>
                                                <div className="profile-custom-input-wrapper">
                                                    {
                                                        this.state.socialNetworksLoaded ?
                                                            <React.Fragment>
                                                                <InstagramLogo size={20} className="logo-inside-input" />
                                                                <div className="vertical-line"></div>
                                                                <Input className="custom-input sm-font-size pl-45px" id="instagram" type="url" name="instagram" value={this.state.instagram} onChange={this.changeInstagram}></Input>
                                                            </React.Fragment>
                                                            :
                                                            <Skeleton height={38} button={true} />
                                                    }
                                                </div>
                                            </FormGroup>
                                        </Col>
                                        <Col xs={12} sm={6} md={4}>
                                            <FormGroup>
                                                <Label className="custom-label xs-font-size" for="slack">{t('profile-slack')}</Label>
                                                <div className="profile-custom-input-wrapper">
                                                    {
                                                        this.state.socialNetworksLoaded ?
                                                            <React.Fragment>
                                                                <SlackLogo size={20} className="logo-inside-input" />
                                                                <div className="vertical-line"></div>
                                                                <Input className="custom-input sm-font-size pl-45px" id="slack" type="url" name="slack" value={this.state.slack} onChange={this.changeSlack}></Input>
                                                            </React.Fragment>
                                                            :
                                                            <Skeleton height={38} button={true} />
                                                    }
                                                </div>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                </div>
                                {/* <div className="profile-card-bottom">
                                    <Button type="submit" className="btn profile-avatar-btn primary sm-font-size">{t('profile-save')}</Button>
                                    <Button type="button" className="btn profile-avatar-btn white ml-10px sm-font-size">{t('profile-cancel')}</Button>
                                </div> */}
                            </div>
                        </Form>
                    </Col>
                </Row>
                <Row className="profile-row w-100 mx-0">
                    <Col lg={12} xl={6} className="d-flex align-items-stretch pl-0 profile-bottom-cards">
                        <Card className="profile-card d-flex flex-column">
                            <div className="personal-info-title">
                                <ListBullets size={20} />
                                <div className="personal-info-text lg-font-size">{t('profile-activity-history')}</div>
                            </div>
                            <Row>
                                <table className="table profile-table">
                                    <tbody>
                                        {
                                            this.state.userLogsLoaded ?
                                                this.state.logs.map((log, index) => (
                                                    <Log key={`log-${index}`}
                                                        id={index}
                                                        text={log.data}
                                                        time={log.createdAt}
                                                        type={log.type}
                                                        view={'profile'}
                                                    />
                                                ))
                                                :
                                                <React.Fragment>
                                                    <Log skeleton={true} />
                                                    <Log skeleton={true} />
                                                    <Log skeleton={true} />
                                                </React.Fragment>
                                        }
                                    </tbody>
                                </table>
                            </Row>
                            <div className="profile-card-bottom">
                                {
                                    this.state.userLogsLoaded ?
                                        <Button
                                            type="button"
                                            className="btn profile-avatar-btn white ml-10px mt-17px sm-font-size"
                                            onClick={() => this.routeTo('logs')}
                                        >
                                            {t('profile-all-history')}
                                        </Button>
                                        :
                                        <Skeleton button={true} className="btn ml-10px mt-17px sm-font-size" width={'40%'} />
                                }
                            </div>
                        </Card>
                    </Col>
                    <Col lg={12} xl={6} className="d-flex align-items-stretch pr-0 profile-bottom-cards">
                        <Card className="profile-card d-flex flex-column">
                            <div className="personal-info-title p-0">
                                <ListBullets size={20} />
                                <div className="personal-info-text lg-font-size">{t('profile-notifications')}</div>
                            </div>
                            <div className="perfonal-info-desc pb-20px pt-7px sm-font-size">{t('profile-notify-about')}</div>
                            {
                                this.state.notsLoaded ?
                                    <table className="custom-table sm-font-size">
                                        <thead>
                                            <tr className="custom-tr">
                                                <th className="custom-th">{t('profile-module')}</th>
                                                <th className="custom-th">{t('profile-email')}</th>
                                                <th className="custom-th">{t('profile-message')}</th>
                                                <th className="custom-th">{t('profile-sms')}</th>
                                                <th className="custom-th">{t('profile-push')}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <th scope="row" className="custom-subth">{t('profile-news')}</th>
                                                <td><input className="custom-input d-block mx-auto" type="checkbox" checked={this.state.nots.news.email} onChange={(e) => this.changeNot(e, 'news', 'email')} /></td>
                                                <td><input className="custom-input d-block mx-auto" type="checkbox" checked={this.state.nots.news.messages} onChange={(e) => this.changeNot(e, 'news', 'messages')} /></td>
                                                <td><input className="custom-input d-block mx-auto" type="checkbox" checked={this.state.nots.news.sms} onChange={(e) => this.changeNot(e, 'news', 'sms')} /></td>
                                                <td><input className="custom-input d-block mx-auto" type="checkbox" checked={this.state.nots.news.push} onChange={(e) => this.changeNot(e, 'news', 'push')} /></td>
                                            </tr>
                                            <tr>
                                                <th scope="row" className="custom-subth">{t('profile-promotions')}</th>
                                                <td><input className="custom-input d-block mx-auto" type="checkbox" checked={this.state.nots.promotions.email} onChange={(e) => this.changeNot(e, 'promotions', 'email')} /></td>
                                                <td><input className="custom-input d-block mx-auto" type="checkbox" checked={this.state.nots.promotions.messages} onChange={(e) => this.changeNot(e, 'promotions', 'messages')} /></td>
                                                <td><input className="custom-input d-block mx-auto" type="checkbox" checked={this.state.nots.promotions.sms} onChange={(e) => this.changeNot(e, 'promotions', 'sms')} /></td>
                                                <td><input className="custom-input d-block mx-auto" type="checkbox" checked={this.state.nots.promotions.push} onChange={(e) => this.changeNot(e, 'promotions', 'push')} /></td>
                                            </tr>
                                            <tr>
                                                <th scope="row" className="custom-subth">{t('profile-messages')}</th>
                                                <td><input className="custom-input d-block mx-auto" type="checkbox" checked={this.state.nots.messages.email} onChange={(e) => this.changeNot(e, 'messages', 'email')} /></td>
                                                <td><input className="custom-input d-block mx-auto" type="checkbox" checked={this.state.nots.messages.messages} onChange={(e) => this.changeNot(e, 'messages', 'messages')} /></td>
                                                <td><input className="custom-input d-block mx-auto" type="checkbox" checked={this.state.nots.messages.sms} onChange={(e) => this.changeNot(e, 'messages', 'sms')} /></td>
                                                <td><input className="custom-input d-block mx-auto" type="checkbox" checked={this.state.nots.messages.push} onChange={(e) => this.changeNot(e, 'messages', 'push')} /></td>
                                            </tr>
                                            <tr>
                                                <th scope="row" className="custom-subth">{t('profile-webinars')}</th>
                                                <td><input className="custom-input d-block mx-auto" type="checkbox" checked={this.state.nots.webinars.email} onChange={(e) => this.changeNot(e, 'webinars', 'email')} /></td>
                                                <td><input className="custom-input d-block mx-auto" type="checkbox" checked={this.state.nots.webinars.messages} onChange={(e) => this.changeNot(e, 'webinars', 'messages')} /></td>
                                                <td><input className="custom-input d-block mx-auto" type="checkbox" checked={this.state.nots.webinars.sms} onChange={(e) => this.changeNot(e, 'webinars', 'sms')} /></td>
                                                <td><input className="custom-input d-block mx-auto" type="checkbox" checked={this.state.nots.webinars.push} onChange={(e) => this.changeNot(e, 'webinars', 'push')} /></td>
                                            </tr>
                                            <tr>
                                                <th scope="row" className="custom-subth">{t('profile-account-login')}</th>
                                                <td><input className="custom-input d-block mx-auto" type="checkbox" checked={this.state.nots.login.email} onChange={(e) => this.changeNot(e, 'login', 'email')} /></td>
                                                <td><input className="custom-input d-block mx-auto" type="checkbox" checked={this.state.nots.login.messages} onChange={(e) => this.changeNot(e, 'login', 'messages')} /></td>
                                                <td><input className="custom-input d-block mx-auto" type="checkbox" checked={this.state.nots.login.sms} onChange={(e) => this.changeNot(e, 'login', 'sms')} /></td>
                                                <td><input className="custom-input d-block mx-auto" type="checkbox" checked={this.state.nots.login.push} onChange={(e) => this.changeNot(e, 'login', 'push')} /></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    :
                                    <Skeleton width={450} height={250} className="d-block mx-auto" />
                            }
                        </Card>
                    </Col>
                </Row>
            </div>
        )
    }
}

Profile.propTypes = {
    t: PropTypes.func,
    i18n: PropTypes.object,
    history: PropTypes.object,
}

export default withTranslation()(Profile)



// WEBPACK FOOTER //
// ./src/views/Profile/Profile.jsx